// src/contexts/AuthContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import {
  OAuthProvider,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  onAuthStateChanged,
  signOut
} from 'firebase/auth';
import { auth } from '../firebase';

// Check if running in emulator/test mode
const useEmulators = process.env.REACT_APP_USE_EMULATORS === 'true';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading]         = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, user => {
      setCurrentUser(user);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  // function loginWithMicrosoft() {
  //   const provider = new OAuthProvider("microsoft.com");
  //   // these scopes trigger the Outlook consent screen:
  //   provider.addScope("https://graph.microsoft.com/User.Read");
  //   provider.addScope("https://graph.microsoft.com/Mail.ReadWrite");
  //   provider.addScope("https://graph.microsoft.com/Mail.Send");
  //   return signInWithPopup(auth, provider)
  //     .then(async (result) => {
  //       // extract the OAuth credential
  //       const credential = OAuthProvider.credentialFromResult(result);
  //       if (credential?.accessToken) {
  //         // persist into Firestore under users/{uid}/msalCache/cache
  //         const uid = result.user.uid;
  //         const cacheRef = doc(db, "users", uid, "msalCache", "cache");
  //         await setDoc(cacheRef, {
  //           serialized: credential.accessToken,
  //           updatedAt: serverTimestamp()
  //         });
  //       }
  //       return result;
  //     });
  // }
  function loginWithMicrosoft() {
    const provider = new OAuthProvider("microsoft.com");
    // only request basic OpenID Connect scopes—no admin consent needed
    provider.addScope("openid");
    provider.addScope("profile");

    // simple Firebase Auth sign-in
    return signInWithPopup(auth, provider);
  }

  function logout() {
    return signOut(auth);
  }

  // Email/password login for test mode (emulators only)
  async function loginWithEmailPassword(email, password) {
    if (!useEmulators) {
      throw new Error('Email/password login is only available in test mode');
    }
    try {
      // Try to sign in first
      return await signInWithEmailAndPassword(auth, email, password);
    } catch (error) {
      // If user doesn't exist, create them (for test convenience)
      if (error.code === 'auth/user-not-found') {
        return await createUserWithEmailAndPassword(auth, email, password);
      }
      throw error;
    }
  }

  const value = { currentUser, loginWithMicrosoft, loginWithEmailPassword, logout, useEmulators };

  return (
    <AuthContext.Provider value={value}>
      { !loading && children }
    </AuthContext.Provider>
  );
}
